import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import './style.scss'
import CloseButton from '../../CloseButton'

const modalDiv = document.getElementById('modal')

const CommonModal = ({ onClose, children }) => {
    useEffect(() => {
        const closeOnEscape = (e) => {
            if (e.keyCode === 27) {
                onClose()
            }
        }

        window.addEventListener('keydown', closeOnEscape)
        return () => window.removeEventListener('keydown', closeOnEscape)
    }, [])

    const modal = (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-wrap" onClick={(e) => e.stopPropagation()}>
                <div className="close-button-wrapper">
                    <CloseButton onClick={onClose} size={20} />
                </div>
                <div>{children}</div>
            </div>
        </div>
    )
    return ReactDOM.createPortal(modal, modalDiv)
}

CommonModal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
}

export default CommonModal
